module.exports = __webpack_public_path__ + "static/media/Hero-image.cf5f0333.jpg";